import {useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {Facility} from "../typedefs";
import {useQuery} from "react-query";
import {useAuth} from "../../../context/user";
import useDebouncer from "../../../hooks/debouncer";

export async function fetchFacilities(page: number, limit: number, search: string, clientID: string | null, departmentID?: string | null) {
    const res = await platformAPI.get<PaginatedResponseV2<Facility>>("api/facilities", {
        params: { page, limit, search, ...(clientID ? {clientID} : {}), ...(departmentID ? {departmentID} : {}) }
    })
    return res.data
}


export function useGetFacilities(clientID: string | null, initialSearch = "", initialPage = 1) {
    const [page, setPage] = useState(initialPage);
    const [rpp, setRPP] = useState(20);
    const [search, setSearch] = useState(initialSearch);

    const debouncedSearch = useDebouncer(search, 300);


    const auth = useAuth();

    const {data, isLoading, error, refetch} = useQuery(
        ["facilities", clientID, page, rpp, debouncedSearch],
        () => fetchFacilities(page, rpp, debouncedSearch, clientID),
        {
            enabled: !!clientID || !auth.isSuperAdmin,
            cacheTime: 0,
            refetchOnMount: true,
        }
    );

    return {
        page, setPage,
        rpp, setRPP,
        search, setSearch,
        data,
        isLoading,
        error,
        refetch
    }


}